<template>
  <div class="modes">
    <span
      class="mode"
      v-for="(opt,index) in options"
      :key="opt"
      :class="{selected: selected === index}"
      @click="handleSelection(index, $event)"
    >{{opt}}</span>
  </div>
</template>

<script>
export default {
  name: "Selector",
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    selected: 0
  }),
  methods: {
    handleSelection(index) {
      this.selected = index;
      this.$emit("input", this.options[index]);
    }
  }
};
</script>

<style scoped>
.modes {
  background: #f9fafb;
  height: 2rem;
  border-radius: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  margin-right: 0.6rem;
  user-select: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.mode {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.mode:hover {
  background: var(--color-grey);
}

.mode.selected {
  background: var(--color-grey);
}
</style>